const filterCriterionUiType = {
    UI_TYPE_NOT_APPLICABLE : 0,

    UI_TYPE_TEXT_INPUT : 1,

    UI_TYPE_SINGLE_SELECT : 2,

    UI_TYPE_MULTI_SELECT : 3,

    UI_TYPE_RADIO_BUTTON : 4,

    UI_TYPE_CHECKBOX : 5,

    UI_TYPE_YES_NO : 6,

    UI_TYPE_ONE_SELECTION : 7,

    UI_DATE_RANGE : 8,

    UI_TYPE_AHEAD : 9,

    UI_BREAKER : 10,

    UI_DATE_RANGE_LOCAL_TIMEZONE : 11

};

angular.module('gw-um-j2js')
    .constant('filterCriterionUiType', filterCriterionUiType);